<script>
import ConfirmationCheckboxes from './ConfirmationCheckboxes.vue'
import ConfirmationCheckbox from './ConfirmationCheckbox.vue'
import ConfirmationRadioGroup from './ConfirmationRadioGroup.vue'
import CostCenterTextField from './CostCenterTextField.vue'

export default {
  components: {
    ConfirmationRadioGroup,
    ConfirmationCheckbox,
    ConfirmationCheckboxes,
    CostCenterTextField
  },
  props: {
    value: {
      type: Object
    },
    fillWidth: {
      type: Boolean
    },
    locked: {
      type: Boolean
    }
  },
  data: vm => ({
    printMode: {
      title: vm.$t('component.profile.printParameters.page.settings'),
      name: 'PrintMode',
      values: [
        {
          value: vm.$enums.PrintMode.Simplex,
          label: vm.$t('component.profile.printParameters.one.sided')
        },
        {
          value: vm.$enums.PrintMode.Duplex,
          label: vm.$t('component.profile.printParameters.double.sided')
        }
      ]
    },
    colorMode: {
      title: vm.$t('component.profile.printParameters.color.settings'),
      name: 'ColorMode',
      values: [
        {
          value: vm.$enums.ColorMode.Color,
          label: vm.$t('component.profile.printParameters.colored')
        },
        {
          value: vm.$enums.ColorMode.Sw,
          label: vm.$t('component.profile.printParameters.black.and.white')
        }
      ]
    },
    frankingType: {
      title: vm.$t('component.profile.printParameters.franking.settings'),
      name: 'FrankingType',
      values: [
        {
          value: vm.$enums.FrankingType.DVFr,
          label: vm.$t('component.profile.printParameters.dv.franking'),
          text: vm.$t('component.profile.printParameters.dv.franking.text')
        },
        {
          value: vm.$enums.FrankingType.Envelope,
          label: vm.$t('component.profile.printParameters.on.envelope'),
          text: vm.$t('component.profile.printParameters.on.envelope.text')
        }
      ]
    },
    confirmProductionArea: {
      title: vm.$t('component.profile.printParameters.production.area'),
      label: vm.$t('component.profile.printParameters.production.area.label')
    },
    confirmFontWarnings: {
      title: vm.$t('component.profile.printParameters.font'),
      label: vm.$t('component.profile.printParameters.font.text')
    },
    merge: {
      title: vm.$t('component.profile.printParameters.merge'),
      values: {
        address: {
          title: vm.$t('component.profile.printParameters.merge.address.title'),
          label: vm.$t('component.profile.printParameters.merge.address.label')
        },
        custom: {
          title: vm.$t( 'component.profile.printParameters.merge.custom.title'),
          label: vm.$t( 'component.profile.printParameters.merge.custom.label')
        }
      }
    },
    foldType: {
      title: vm.$t( 'component.profile.printParameters.fold.type'),
      name: 'foldType',
      values: [
        {
          value: vm.$enums.FoldType.Size105,
          label: vm.$t( 'component.profile.printParameters.fold.type.105.label'),
          text: vm.$t( 'component.profile.printParameters.fold.type.105.text')
        },
        {
          value: vm.$enums.FoldType.Size87,
          label: vm.$t( 'component.profile.printParameters.fold.type.87.label'),
          text: vm.$t( 'component.profile.printParameters.fold.type.87.text')
        }
      ]
    },
    defaultCostCenter: {
      title: vm.$t( 'component.profile.printParameters.cost.center'),
      label: vm.$t( 'component.profile.printParameters.cost.center'),
      text: vm.$t( 'component.profile.printParameters.cost.center.text.1')
    }
  }),
  computed: {
    isMobile: function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true
        default:
          return false
      }
    }
  }
}
</script>
<template>
  <v-card :disabled="locked" flat class="ma-0 pa-0">
    <ConfirmationRadioGroup
      id="print-mode-radio-group"
      v-model="value.printMode"
      :title="printMode.title"
      :row="!isMobile"
      :values="printMode.values"
      :name="printMode.name"
      :fill-width="fillWidth"
    />
    <ConfirmationRadioGroup
      v-if="$permissions.hasBlackAndWhite"
      id="color-mode-radio-group"
      v-model="value.colorMode"
      :title="colorMode.title"
      :row="!isMobile"
      :values="colorMode.values"
      :name="colorMode.name"
      :fill-width="fillWidth"
    />
    <ConfirmationRadioGroup
      v-if="($permissions.hasFrankingOnEnvelope)"
      id="franking-type-radio-group"
      v-model="value.frankingType"
      :title="frankingType.title"
      :values="frankingType.values"
      :name="frankingType.name"
      :fill-width="fillWidth"
      bold-label
    />
    <ConfirmationRadioGroup
      v-if="$permissions.hasFoldType"
      id="fold-type-radio-group"
      v-model="value.foldType"
      :row="!isMobile"
      :title="foldType.title"
      :values="foldType.values"
      :name="foldType.name"
      :fill-width="fillWidth"
      bold-label
    />
    <ConfirmationCheckboxes
      v-if="$permissions.hasMergeLetters"
      id="merge-checkboxes"
      v-model="value.merge"
      :values="merge.values"
      :fill-width="fillWidth"
      :title="merge.title"
    >
    </ConfirmationCheckboxes>
    <ConfirmationCheckbox
      id="confirm-production-area-checkbox"
      v-model="value.confirmProductionArea"
      :title="confirmProductionArea.title"
      :label="confirmProductionArea.label"
      :fill-width="fillWidth"
    />
    <ConfirmationCheckbox
      v-if="$permissions.hasFontValidationOverride"
      id="confirm-font-warnings-checkbox"
      v-model="value.confirmFontWarnings"
      :title="confirmFontWarnings.title"
      :label="confirmFontWarnings.label"
      :fill-width="fillWidth"
    />
<!--    <ShippingManager-->
<!--      v-if="$permissions.hasOrderAutocomplete"-->
<!--      v-model="value.orderSchedule"-->
<!--      :fill-width="fillWidth"-->
<!--      bold-label-->
<!--    />-->
    <CostCenterTextField
      v-if="$permissions.hasCostCenter"
      id="default-cost-center-text-field"
      v-model="value.defaultCostCenter"
      :label="defaultCostCenter.label"
      :title="defaultCostCenter.title"
      :text="defaultCostCenter.text"
      :fill-width="fillWidth"
    />
  </v-card>
</template>
